
export const sFechaPublicacion = '2026-09-08T15:58:29.7523013-06:00';
export const sVersion = 'vf1.1.609081558';
            